(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './peachjar-portal'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./peachjar-portal'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.peachjarPortal);
    global.index = mod.exports;
  }
})(this, function (exports, _peachjarPortal) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.portal = undefined;

  var _peachjarPortal2 = _interopRequireDefault(_peachjarPortal);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.portal = _peachjarPortal2.default;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/styles/themes/index.js
// module id = 1561
// module chunks = 1